/* styled-components & other non-external style-related exports (like, say, a `headerHeight` var) go here */
import { font, colors, spacing, visuallyHiddenCss } from '@chegg-ui/theme';
import styled from 'styled-components';
var helperTextHeight = font.size.px12;
var helperTextMargin = "".concat(10 / 16, "rem");
export var FormGroup = styled.div.withConfig({
  componentId: "sc-1ftnaog-0"
})(["position:relative;width:", ";", ""], function (_ref) {
  var width = _ref.width;
  return width || 'auto';
}, function (_ref2) {
  var errorText = _ref2.errorText,
      helperText = _ref2.helperText;
  return helperText || errorText ? "margin-bottom: .375rem;" : "margin-bottom: calc(".concat(helperTextHeight, " + ").concat(helperTextMargin, ");");
});
export var Label = styled.label.withConfig({
  componentId: "sc-1ftnaog-1"
})(["", ""], function (_ref3) {
  var visuallyHidden = _ref3.visuallyHidden,
      adjustToBackgroundColor = _ref3.adjustToBackgroundColor,
      customTheme = _ref3.customTheme,
      disabled = _ref3.disabled;
  return visuallyHidden ? visuallyHiddenCss : "\n  font-family: ".concat(font.family["default"], ";\n  font-size: ").concat(customTheme.labelfontSize, ";\n  color: ").concat(adjustToBackgroundColor ? colors.white : disabled ? customTheme.disabledFontColor : customTheme.labelColor, ";\n  padding: 0px;\n  padding-bottom: ").concat(customTheme.labelPaddingBottom, ";\n  display: block;\n  font-weight: ").concat(font.weight.bold, ";\n  line-height: ").concat(customTheme.labelLineHeight, ";\n  &:hover {\n    cursor: text;\n  }\n  ");
});
export var LeadingIconPositioner = styled.div.withConfig({
  componentId: "sc-1ftnaog-2"
})(["position:absolute;top:50%;left:", ";transform:translateY(-50%);display:flex;pointer-events:", ";color:", ";"], function (_ref4) {
  var customTheme = _ref4.customTheme;
  return customTheme.leadingIconLeft;
}, function (_ref5) {
  var leadingIconClickable = _ref5.leadingIconClickable;
  return leadingIconClickable ? 'auto' : 'none';
}, function (_ref6) {
  var disabled = _ref6.disabled,
      customTheme = _ref6.customTheme;
  return disabled ? customTheme.leadingIconDisabledColor : customTheme.leadingIconColor;
});
export var HelperText = styled.div.withConfig({
  componentId: "sc-1ftnaog-3"
})(["color:", ";font-family:", ";font-size:", ";height:", ";margin-top:", ";padding-left:", ";display:flex;line-height:", ";"], function (_ref7) {
  var adjustToBackgroundColor = _ref7.adjustToBackgroundColor,
      customTheme = _ref7.customTheme,
      disabled = _ref7.disabled;
  return adjustToBackgroundColor ? colors.white : disabled ? customTheme.disabledFontColor : customTheme.helperTextColor;
}, font.family["default"], function (_ref8) {
  var customTheme = _ref8.customTheme;
  return customTheme.helperTextFontSize;
}, helperTextHeight, function (_ref9) {
  var customTheme = _ref9.customTheme;
  return customTheme.helperTextMarginTop;
}, function (_ref10) {
  var customTheme = _ref10.customTheme;
  return customTheme.helperTextPaddingLeft;
}, function (_ref11) {
  var customTheme = _ref11.customTheme;
  return customTheme.helperTextLineHeight;
});
export var Error = styled(HelperText).withConfig({
  componentId: "sc-1ftnaog-4"
})(["color:", ";"], function (_ref12) {
  var customTheme = _ref12.customTheme;
  return customTheme.errorTextColor;
});
export var TrailingIconPositioner = styled.div.withConfig({
  componentId: "sc-1ftnaog-5"
})(["position:absolute;top:50%;right:", ";transform:translateY(-50%);display:flex;pointer-events:", ";color:", ";", ""], function (_ref13) {
  var customTheme = _ref13.customTheme;
  return customTheme.trailingIconRight;
}, function (_ref14) {
  var trailingIconClickable = _ref14.trailingIconClickable;
  return trailingIconClickable ? 'auto' : 'none';
}, function (_ref15) {
  var customTheme = _ref15.customTheme;
  return customTheme.trailingIconColor;
}, function (_ref16) {
  var disabled = _ref16.disabled,
      customTheme = _ref16.customTheme;
  return disabled && "color: ".concat(customTheme.trailingIconDisabledColor, ";");
});
export var FloatingLabel = styled.label.withConfig({
  componentId: "sc-1ftnaog-6"
})(["position:absolute;font-family:", ";font-size:", ";color:", ";top:", ";z-index:1;transition:all 0.2s ease-out;pointer-events:none;line-height:", ";&:hover{cursor:text;}", " @media (prefers-reduced-motion:reduce){transition:none;}"], font.family["default"], function (_ref17) {
  var customTheme = _ref17.customTheme;
  return customTheme.floatingLabelfontSize;
}, function (_ref18) {
  var adjustToBackgroundColor = _ref18.adjustToBackgroundColor,
      customTheme = _ref18.customTheme;
  return adjustToBackgroundColor ? colors.white : customTheme.labelColor;
}, function (_ref19) {
  var setLabelOffset = _ref19.setLabelOffset,
      hasLeadingIcon = _ref19.hasLeadingIcon;
  return setLabelOffset ? '0.9rem' : hasLeadingIcon ? '0.25rem' : '1.25rem';
}, function (_ref20) {
  var customTheme = _ref20.customTheme;
  return customTheme.labelLineHeight;
}, function (_ref21) {
  var isFloating = _ref21.isFloating;
  return isFloating && "\n      top: ".concat(spacing.px8, ";\n      font-size: ").concat(font.size.px12, ";\n      font-weight: ").concat(font.weight.bold, ";\n    ");
});
export var FloatingHelperText = styled(HelperText).withConfig({
  componentId: "sc-1ftnaog-7"
})(["padding-left:0;"]);
export var FloatingError = styled(Error).withConfig({
  componentId: "sc-1ftnaog-8"
})(["padding-left:0;"]);
export var FloatingLeadingIconPositioner = styled.div.withConfig({
  componentId: "sc-1ftnaog-9"
})(["position:absolute;top:70%;transform:translateY(-50%);left:0;display:flex;pointer-events:none;transition:all 0.2s ease-out;@media (prefers-reduced-motion:reduce){transition:none;}", " ", ""], function (_ref22) {
  var disabled = _ref22.disabled;
  return disabled && "color: ".concat(colors.grey, ";");
}, function (_ref23) {
  var adjustToBackgroundColor = _ref23.adjustToBackgroundColor;
  return adjustToBackgroundColor && "color: ".concat(colors.white, ";");
});
export var FloatingTrailingIconPositioner = styled.div.withConfig({
  componentId: "sc-1ftnaog-10"
})(["position:absolute;top:70%;transform:translateY(-50%);right:0;display:flex;pointer-events:", ";transition:all 0.2s ease-out;@media (prefers-reduced-motion:reduce){transition:none;}", " ", ""], function (_ref24) {
  var trailingIconClickable = _ref24.trailingIconClickable;
  return trailingIconClickable ? 'auto' : 'none';
}, function (_ref25) {
  var disabled = _ref25.disabled;
  return disabled && "color: ".concat(colors.grey, ";");
}, function (_ref26) {
  var adjustToBackgroundColor = _ref26.adjustToBackgroundColor;
  return adjustToBackgroundColor && "color: ".concat(colors.white, ";");
});
export var getThemeConfig = function getThemeConfig(themeProp) {
  return {
    "default": function _default(theme) {
      return {
        labelColor: theme.colors.border.dark900,
        labelfontSize: theme.font.size.xs,
        floatingLabelfontSize: theme.font.size.md,
        labelLineHeight: theme.font.lineHeight.sm,
        labelPaddingBottom: theme.spacing.xs,
        leadingIconLeft: theme.spacing.md,
        leadingIconDisabledColor: theme.colors.border.medium500,
        leadingIconColor: theme.colors.border.medium700,
        helperTextColor: theme.colors.border.dark700,
        helperTextFontSize: theme.font.size.xxs,
        errorTextColor: theme.colors.error.dark,
        helperTextMarginTop: theme.spacing.xxs,
        helperTextLineHeight: theme.font.lineHeight.sm,
        trailingIconRight: theme.spacing.md,
        trailingIconDisabledColor: theme.colors.border.medium500,
        trailingIconColor: theme.colors.border.medium700,
        disabledFontColor: theme.colors.border.medium500,
        helperTextPaddingLeft: '0',
        showCancelIcon: true
      };
    },
    fanta: function fanta(theme) {
      return {
        labelColor: colors.grey,
        labelfontSize: theme.font.size.xxs,
        labelLineHeight: 'initial',
        labelPaddingBottom: '0.4375rem',
        leadingIconLeft: theme.spacing.xs,
        leadingIconDisabledColor: colors.grey,
        leadingIconColor: colors.dark,
        helperTextColor: colors.grey,
        helperTextFontSize: font.size.px14,
        helperTextPaddingLeft: theme.spacing.md,
        errorTextColor: colors.errorRed,
        helperTextMarginTop: spacing.px4,
        helperTextLineHeight: 'initial',
        showCancelIcon: false,
        trailingIconRight: theme.spacing.xs,
        trailingIconDisabledColor: colors.grey,
        trailingIconColor: colors.dark,
        disabledFontColor: colors.grey
      };
    },
    prop: themeProp
  };
};
export var ErrorText = styled.div.withConfig({
  componentId: "sc-1ftnaog-11"
})(["margin-left:4px;"]);